import React, { Suspense, useEffect, useLayoutEffect, useRef } from "react";
import {
  Outlet,
  RouterProvider,
  createBrowserRouter,
  useLocation,
} from "react-router-dom";
import store from "../app-services/store";
import C404 from "../components/C404/C404";
import Alert from "../partials/Alert/Alert";
import GuardRoute from "../partials/GuardRoute/GuardRoute";
import getDevice from "../app-services/lib/device";
import routes from "./routes";
import "../lib/bootstrap-grid.min.css";

import "./AppLayout.css";
import "../Fonts.css";
import ScrollToTop from "./ScrollToTop";
import api from "../app-services/API";

import PopupLogin from "../components/PopupLogin/PopupLogin";

/**
 * Persistent root of the route tree (rendered once, never remounted by
 * navigation — child routes swap via <Outlet/>). Replaces v5's
 * SwitchContainer: same body-class bookkeeping and "route actually changed"
 * detection, driven by useLocation() instead of the withRouter-injected
 * props.location.
 */
function RootLayout(props) {
  const self = useRef({}).current;
  const prevLocationRef = useRef(undefined);
  const location = useLocation();
  self.props = props;

  useLayoutEffect(() => {
    initialConstruct.bind(self)("SwitchContainer", props);
  }, []);

  const addBodyClass = () => {
    let bookname = location.pathname.pluck(1);
    removeBodyClass();
    document.querySelector("body").classList.add("page-" + bookname);
  };

  const removeBodyClass = () => {
    document.querySelector("body").classList = [
      ...document.querySelector("#root").classList,
    ].filter((o) => !o.includes("page-"));
  };

  const onRouteChanged = () => {
    Modal?.state?.list.find((o) => o.type == "model")?.close();
    if (document.body.style.overflow === "hidden") {
      document.body.style.overflow = "";
      console.log("Hello World");
    }
    addBodyClass();
  };

  useEffect(() => {
    const isInitialMount = prevLocationRef.current === undefined;
    if (isInitialMount) {
      prevLocationRef.current = location;
      return;
    }
    if (prevLocationRef.current !== location) {
      onRouteChanged();
      prevLocationRef.current = location;
    }
  }, [location]);

  return (
    <Suspense fallback={<h1>loading...</h1>}>
      <div className={"main " + props.store.device}>
        <Alert />
        <ScrollToTop>
          <Outlet />
        </ScrollToTop>
        {!mixins.appmode()}
      </div>
    </Suspense>
  );
}

const RootLayoutContainer = connect(RootLayout);

const router = createBrowserRouter([
  {
    element: <RootLayoutContainer />,
    children: [
      ...routes.map((prop) => ({
        path: prop.path,
        element: <GuardRoute path={prop.path} component={prop.component} />,
      })),
      {
        path: "/404",
        element: <GuardRoute path="/404" component={C404} />,
      },
    ],
  },
]);

export function AppLayout(props) {
  const self = useRef({}).current;
  self.props = props;

  useLayoutEffect(() => {
    initialConstruct.bind(self)("AppLayout", props);
  }, []);

  const getCartDetails = () => {
    return new Promise((resolve, reject) => {
      if (props.store.user !== null) {
        api
          .getCartDetails()
          .then((res) => {
            if (res && res.statusCode === 200 && res.data) {
              resolve(res.data);
            }
            reject();
          })
          .catch(reject);
      } else {
        resolve([]);
      }
    });
  };

  const handleMouseScroll = () => {
    if (document.body.style.overflow == "hidden") {
      document.body.style.overflow = "";
    }
  };

  self.getCartDetails = getCartDetails;

  useEffect(() => {
    window.onresize = function () {
      self.setStore("device", getDevice().class);
    };
    api.getSessionID().then((sessionID) => {
      let localSessionID = localStorage.getItem("sessionID");
      localStorage.setItem("sessionID", localSessionID || sessionID);
    });
    api
      .getuserProfile()
      .then((res) => {
        getCartDetails().then((cartItem) => {
          self.setStore([
            { name: "cart_list", value: cartItem || [] },
            { name: "cartItem", value: cartItem.totalNumberOfBooks },
            { name: "user", value: res.data },
            { name: "device", value: getDevice().class },
          ]);
        });
      })
      .catch((err) => {
        self.setStore("device", getDevice().class);
      });
  }, []);

  useEffect(() => {
    window.addEventListener("wheel", handleMouseScroll);
    window.addEventListener("mousedown", handleMouseScroll);
    window.addEventListener("keydown", handleMouseScroll);

    window.login_popup = () =>
      alert((alertVar) => <PopupLogin model={alertVar} />, "", "login", {
        footer: false,
      });
    emit.on("openloader", (payload) => {
      loader(payload);
    });
    emit.on("closeloader", (callback = () => true) => {
      let modal = Modal.state.list.find((o) => o.type == "info" && callback(o));

      modal.close();
    });

    return () => {
      window.removeEventListener("wheel", handleMouseScroll);
      window.removeEventListener("mousedown", handleMouseScroll);
      window.removeEventListener("keydown", handleMouseScroll);

      emit.remove("openloader");
      emit.remove("closeloader");
    };
  }, []);

  return <RouterProvider router={router} />;
}

export default connect(AppLayout);
